/* eslint-disable import/no-mutable-exports */

interface CustomerEmail {
  [key: string]: any;
}

export let customerEmail: CustomerEmail = {};
export const initCustomerEmailData = () => {
  customerEmail = { ...customerEmail, unsubscribeIdentifier: '' };
};

export default customerEmail;
